<template>
    <div class="w3-container w3-light-grey w3-round-large options-group">
      <!-- 嵌入內容 -->
      <slot></slot>
    </div>
</template>
<script>
export default {
  name: "OptionsGroup",
  data() {
    return {};
  },
  components: {},
  updated() {},
  mounted() {},
  methods: {

  },
};
</script>
